import { ROOM_RATE_FLASH_TYPE, ROOM_RATE_LAST_MINUTE_TYPE, ROOM_RATE_LPC_TYPE } from '~/consts/ratePlans';

export type RatePlanProductGroup = 'flash' | 'dynamic' | 'other';
export type RatePlanStatusGroup = 'active' | 'hidden' | 'draft' | 'unknown';

export const RATE_PLAN_PRODUCT_LABELS: Record<RatePlanProductGroup, string> = {
  flash: 'Flash',
  dynamic: 'Dynamic',
  other: 'Other / unspecified',
};

export const RATE_PLAN_STATUS_LABELS: Record<RatePlanStatusGroup, string> = {
  active: 'Active',
  hidden: 'Hidden',
  draft: 'Draft',
  unknown: 'Unknown',
};

export function getRatePlanProductGroup(productType?: string): RatePlanProductGroup {
  if (productType === ROOM_RATE_FLASH_TYPE) return 'flash';
  if (productType === ROOM_RATE_LPC_TYPE || productType === ROOM_RATE_LAST_MINUTE_TYPE) return 'dynamic';
  return 'other';
}

export function getRatePlanStatusGroup(status?: string): RatePlanStatusGroup {
  switch (status) {
    case 'content-approved':
      return 'active';
    case 'hidden':
      return 'hidden';
    case 'draft':
      return 'draft';
    default:
      return 'unknown';
  }
}

export function compareRatePlans(left: App.RatePlan, right: App.RatePlan): number {
  const statusOrder: Record<RatePlanStatusGroup, number> = { active: 0, hidden: 1, draft: 2, unknown: 3 };
  return (
    statusOrder[getRatePlanStatusGroup(left.status)] - statusOrder[getRatePlanStatusGroup(right.status)] ||
    left.name.localeCompare(right.name)
  );
}
